export default "__VITE_ASSET__UDIhZQ6z__"